// extracted by mini-css-extract-plugin
module.exports = {"panel":"Map_panel__3Pi4y"};